module.exports = __webpack_public_path__ + "static/media/404-dogo.45add2fe.jpg";